import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import {
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineGithub,
  AiOutlineLinkedin,
} from "react-icons/ai";
import { 
  FaBriefcase, 
  FaCode, 
  FaStar,
  FaEnvelope
} from "react-icons/fa";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    updateExpanded(false);
  };

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand 
          href="#home" 
          className="d-flex"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('home');
          }}
        >
          <h1 style={{ color: "#CE5FF8" }}>Hassan Abrar</h1>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link 
                href="#home" 
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('home');
                }}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about');
                }}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="#technical-skills"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('technical-skills');
                }}
              >
                <FaCode style={{ marginBottom: "2px" }} /> Skills
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="#professional-experience"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('professional-experience');
                }}
              >
                <FaBriefcase style={{ marginBottom: "2px" }} /> Experience
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="#featured-projects"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('featured-projects');
                }}
              >
                <FaStar style={{ marginBottom: "2px" }} /> Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="#lets-connect"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('lets-connect');
                }}
              >
                <FaEnvelope style={{ marginBottom: "2px" }} /> Contact
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <div style={{ display: "flex" }}>
                <Nav.Link
                  href="https://github.com/HassanAbrar202"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AiOutlineGithub style={{ marginBottom: "2px" }} />
                </Nav.Link>
                <Nav.Link
                  href="https://www.linkedin.com/in/hassan-abrar-86600419a/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AiOutlineLinkedin style={{ marginBottom: "2px" }} />
                </Nav.Link>
              </div>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
